import { Component, Input, TemplateRef, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAlertDialogData } from '@irb/app.model';
import {DomSanitizer} from '@angular/platform-browser';

@Component({ standalone: false,
  selector: 'irb-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss', '../../styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertDialogComponent {
  dTitle: string;
  dProceedBtnLabel: string;
  onProceed: Function;
  onCancel: Function;
  dType: string;
  msg: string;
  altMsg: string;
  altMsgHTML: any; //deprecated, use altMsgTemplate instead
  @Input() altMsgTemplate: TemplateRef<any>;

  constructor(public dialogRef: MatDialogRef<AlertDialogComponent>, @Inject(MAT_DIALOG_DATA) public mdd: IAlertDialogData, private sanitizer: DomSanitizer) {
    this.dTitle = this.mdd.dTitle || "Alert";
    this.dProceedBtnLabel = this.mdd.dProceedBtnLabel || "Close";
    this.onProceed = this.mdd.onProceed || null;
    this.onCancel = this.mdd.onCancel || null;
    this.dType = this.mdd.dType || "NONE";
    this.msg = this.mdd.msg || null;
    this.altMsg = this.mdd.altMsg || null;
    this.altMsgHTML = this.mdd.altMsgHTML || null;
    this.altMsgTemplate = this.mdd.altMsgTemplate || null;

    if (this.altMsgHTML) {
      this.altMsgHTML = sanitizer.bypassSecurityTrustHtml(this.altMsgHTML);
    }
  }

  close() {
    this.cancel();
  }

  continue() {
    if(this.onProceed) {
      this.onProceed();
    }

    this.dialogRef.close();
  }

  cancel() {
    if(this.onCancel) {
      this.onCancel();
    }

    this.dialogRef.close();
  }

}
